export default __webpack_public_path__ + "static/gut-health-detox-a6f55497b535c3c8f95dfc47b3d31b58.png";